import { useCookies } from "react-cookie";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutesAuth = () => {
  const cookies = localStorage;

  var cookieValue = cookies?.user
    ? JSON.parse(atob(cookies?.user))?.User_type
    : false;
  if (!cookieValue) return <Navigate to="/login" />;
  return <Outlet />;
};

export default PrivateRoutesAuth;
